import { render, staticRenderFns } from "./AplicarPago.vue?vue&type=template&id=48f184b6&"
import script from "./AplicarPago.vue?vue&type=script&lang=js&"
export * from "./AplicarPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports